/* eslint-disable no-undef */
(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('UserAuditService', UserAuditService);

  UserAuditService.$inject = ['$resource'];

  function UserAuditService($resource) {
    return $resource(apiUrl + '/user-audits/:id', { id: '@id' }, {
      filterUserAudits: { url: apiUrl + '/user-audits', method: 'GET', isArray: false },
    }
    )
  }
  // eslint-disable-next-line semi
})();
